module.exports = __webpack_public_path__ + "assets/fc1c71b909452b8b63d592e1a0aba819.mp3";